<template>
    <kgr-offering-view
        v-if="offering !== null"
        :club-id="clubId"
        :offering="offering"
        :user-id="userId"
        :error="error"
        :duplicate-training-url="duplicateTrainingUrl"
        :can-duplicate="canDuplicate"
        :can-edit="canEdit"
    />
</template>

<script>
import Error from '../../js/model/Error.js';
import OfferingTrainingView from '../../components/offering/OfferingTrainingView.vue';
import TrainingOfferingRepository from '../../js/repository/club/offering/TrainingOfferingRepository.js';

export default {
    components: {
        'kgr-offering-view': OfferingTrainingView,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        offeringId: {
            type: String,
            required: true,
        },
        userId: {
            type: Number,
            required: true,
        },
        duplicateTrainingUrl: {
            type: String,
            required: true,
        },
        canDuplicate: {
            type: Boolean,
            required: true,
        },
        canEdit: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            showCalendar: true,
            showList: false,
            appointments: [],
            offering: null,
            error: new Error(),
        }
    },
    computed: {},
    created() {
        TrainingOfferingRepository.find(this.offeringId)
            .then(offering => this.offering = offering)
            .catch(() => this.$notify.error('error.loadingData'));
    },
    methods: {},
}

</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
